export const ACTION_CODE = 'TRAINING_SPECIALITIES' + '_ACTION';
